import { render, staticRenderFns } from "./SeparationElement.vue?vue&type=template&id=9c3270e8&scoped=true"
import script from "./SeparationElement.vue?vue&type=script&lang=js"
export * from "./SeparationElement.vue?vue&type=script&lang=js"
import style0 from "./SeparationElement.vue?vue&type=style&index=0&id=9c3270e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3270e8",
  null
  
)

export default component.exports